export default [
  { value: 1, label: 'Affoltern' },
  { value: 2, label: 'Andelfingen' },
  { value: 3, label: 'Bülach' },
  { value: 4, label: 'Dielsdorf' },
  { value: 5, label: 'Dietikon' },
  { value: 6, label: 'Hinwil' },
  { value: 7, label: 'Horgen' },
  { value: 8, label: 'Meilen' },
  { value: 9, label: 'Pfäffikon' },
  { value: 10, label: 'Uster' },
  { value: 11, label: 'Winterthur' },
  { value: 12, label: 'Zürich' },
];
